import React from 'react';

import { useLocalizations } from '@vp/ubik-localizations-provider';

import { sizeDimensionsTabTypename } from '../types/ppV2ContentfulTypes';

import { PdpFlyoutTrigger } from './PdpFlyoutTrigger';
import { SizeDimensions, SizeDimensionsData } from './size-dimensions';

export type SizeAndDimensionsWrapperProps = {
  productKey: string;
  data: SizeDimensionsData;
};
export const SizeDimensionsWrapper: React.FC<SizeAndDimensionsWrapperProps> = (props) => {
  const { t } = useLocalizations();

  return (
    <SizeDimensions
      {...props}
      trigger={
        <PdpFlyoutTrigger
          iconType="printedProducts"
          label={t('sizes-and-dimensions')}
          flyoutType={sizeDimensionsTabTypename}
          productKey={props.productKey}
        />
      }
    />
  );
};
